import {Injectable} from '@angular/core';
import {interval, merge, Observable, Subject} from 'rxjs';
import {startWith} from 'rxjs/operators';

export interface ResizeAnimation {
    stop: () => void;
}

/**
 * Service used to share resizing events across components.
 */
@Injectable()
export class ResizeService {

    private readonly scopes: { [scope: string]: Subject<void> };

    constructor() {
        this.scopes = {
            content: new Subject<void>()
        };
    }

    resize(scopes: string[]) {
        scopes.forEach(scope => {
            if (scope in this.scopes) {
                this.scopes[scope].next();
            }
        });
    }

    startResize(scopes: string[], delay: number): ResizeAnimation {
        const sub = interval(delay).pipe(
            startWith(0),
        ).subscribe(() => {
            this.resize(scopes);
        });
        return {
            stop: () => sub.unsubscribe()
        };
    }

    observe(scopes: string[]): Observable<void> {
        return merge(...(Object.keys(this.scopes)
            .filter(s => scopes.indexOf(s) >= 0)
            .map(s => this.scopes[s].asObservable())));
    }
}
